var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathCrossCountrySkiing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path-skiiing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 3C35.6 3 45 12.4 45 24C45 35.6 35.6 45 24 45C12.4 45 3 35.6 3 24C3 12.4 12.4 3 24 3ZM24 0C10.7 0 0 10.7 0 24C0 37.3 10.7 48 24 48C37.3 48 48 37.3 48 24C48 10.7 37.3 0 24 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2001 13.6C10.6001 13.8 9.70013 15.9 12.2001 16.9V16.2V13.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.2 13.6H12.2V16.1V32.8C11.5 33 11 33.3 11 33.6C11 34 11.5 34.3 12.3 34.4V34.6L13.3 36.5V34.5C14 34.4 14.6 34.1 14.6 33.7C14.6 33.3 14.1 33 13.3 32.9V13.6H13.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.8 13.6H34.8V32.9C34.1 33 33.5 33.3 33.5 33.7C33.5 34.1 34 34.4 34.8 34.5V36.5L35.8 34.6V34.4C36.5 34.3 37.1 34 37.1 33.6C37.1 33.2 36.6 32.9 35.8 32.8V16.8C38.2 15.8 37.3 13.8 35.8 13.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.2001 6.19995L18.8001 10.7V23.5H18.1001V27.4H18.8001V39.7999L20.2001 41.9L21.6001 39.7999V27.4H22.2001V23.5H21.6001V10.7L20.2001 6.19995Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.7998 6.19995L26.3998 10.7V23.5H25.7998V27.4H26.3998V39.7999L27.7998 41.9L29.1998 39.7999V27.4H29.8998V23.5H29.1998V10.7L27.7998 6.19995Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathCrossCountrySkiing);
export default __webpack_public_path__ + "static/media/path-cross-country-skiing.b490ab7f01141b578823a9f45b517d23.svg";
export { ForwardRef as ReactComponent };